import { EventSegmentProps, ProfileSegmentProps } from "../../../pages/cdp/types";
import { generateMiniChart } from "./mini-chart";

export const ProfileSegment: React.FC<ProfileSegmentProps> = ({
  title,
  description,
  chartData,
}) => (
  <div className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-md transition-shadow">
    <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>

    <div className="mb-6">{generateMiniChart(chartData)}</div>

    <p className="text-gray-600 text-sm mb-6">{description}</p>

    <button className="text-blue-600 text-sm font-medium hover:text-blue-700 transition-colors">
      View insights
    </button>
  </div>
);

export const EventSegment: React.FC<EventSegmentProps> = ({
  title,
  description,
  chartData,
}) => (
  <div className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-md transition-shadow">
    <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>

    <div className="mb-6">{generateMiniChart(chartData)}</div>

    <p className="text-gray-600 text-sm mb-6">{description}</p>

    <button className="text-blue-600 text-sm font-medium hover:text-blue-700 transition-colors">
      View events
    </button>
  </div>
);